export default {
  bank: "Bank",
  winlose: "Menang/Kalah",
  balance: "Baki",
  win: "Menang",
  lose: "Kalah",
  tie: "Seri",
  history: "Sejarah",
  transfer_details: "Butiran Pemindahan",
  id: "ID",
  game: "Permainan",
  contactus: "Hubungi Kami",
  join_now: "Sertai Skrg. Juga",
  manual_deposit: "Deposit Manual",

  aboutus: "Mengenai Kami",
  attention: "Perhatian",
  amount_currency: "Jumlah ({currency} Min.: {min} Maks.: {max})",
  all: "Semua",
  amount: "Jumlah",
  approved: "Telah diluluskan",
  and: "dan",
  atm_cash: "ATM/Deposit Tunai",
  account_name: "Nama Akaun",
  account_no: "No. Akaun",
  amount_min: "Jumlah Minimum",
  amount_max: "Jumlah Maksimum",
  amount_not_min: "Jumlah tidak mencapai nilai minimum seperti yang ditetapkan",
  add_bank: "Menambah Bank",
  account_id: "ID Akaun",
  adjustment_details: "Butiran Penyesuaian",
  after_balance: "Baki Selepasnya",
  android: "Android",
  atm: "ATM",
  acc_detail: "Butiran Akaun",
  about_us:{
    headline: "EPICWIN - JENAMA #1 YANG MELINDUNGI KEWANGANMU",
    headlineContent_1: "Terima kasih kerana sudi sertai EpicWin, rerumah bagi Pengalaman Pertaruhan Ajaib yang akan mengubah cara kemenanganmu buat selama-lamanya!",
    headlineContent_2: "Kami mengalu-alukan penyertaan SEMUA GOLONGAN bersama kami. Marilah dan mendapat tahu tentang KEAJAIBAN yang kami menawarkan kepadamu.",
    box_one:{
      title: "BERSATU SEGALA DI BAWAH SATU NAMA",
      content_1: "Segala pengoperasian, penyelidikan & pembangunan, perancangan dan perkhidmatan sokongan mengenai urusan EPICWIN dilaksanakan oleh pasukan operasi khas kami",
    },
    box_two:{
      title: "PROSES BAYARAN",
      title_1: "CEPAT", //custom for malay
      content_1: "Transaksi pendepositan & pengeluaran disempurnakan dalam tempoh seminit dengan kelulusan pantas",
    },
    box_three:{
      title: "MEMBAWAKAN KENIKMATAN YANG ASASI",
      content_1: "Kami mencipta permainan pertaruhan bertaraf dunia dengan nisbah bayar keluar yang tinggi serta menarik dan membawa petaruh kembali menambah lebih banyak keseronokan",
    },
    box_four:{
      title: "NILAL EPICWIN YANG TIADA BANDINGAN",
      content_1: "Kami boleh memberi lebih banyak ganjaran kepada petaruh-petaruh dalam bentuk berlainan - jumlah bayar balik lebih tinggi, unsur pertaruhan ekstra dan tawaran-tawaran khas untuk ahli sahaja tanpa melalui ejen/orang tengah",
    },
    swiperbox_one:{
      title: "PEMBUAT SLOTS #1",
      highlight: "Lebih daripada 120",
      detail: "jenis permainan slots berkualti premium dengan nisbah bayar balik yang tinggi (bilangan semakin hari semakin bertambah)",
      mobile: "Lebih daripada 120 jenis"
    },
    swiperbox_two:{
      title: "PEMBUAT SLOTS SUPERSTAR",
      detail: "Penerbitan permainan dari filem yang menguja & tema permainan sohor kini",
    },
    swiperbox_three:{
      title: "JUMLAH KEAHLIAN EPICWIN",
      highlight: "Mencecah 480,000",
      detail: "sejak 18hb Mac 2018",
      mobile: "480,000"
    },
    swiperbox_four:{
      title: "EPICWIN DAH BAYAR",
      highlight: "Pusing ganti berjumlah RM 235 juta ",
      detail: "sejak 18hb Mac 2018",
      mobile: "RM 235 juta"
    },
    swiperbox_five:{
      title: "PEMBERIAN STRIM LANGSUNG",
      highlight: "RM 60,000 diberikan dalam bentuk bonus",
      detail: "Ganjaran percuma luar biasa berjumlah ",
      mobile: "RM 60,000"
    },
    swiperbox_six:{
      title: "MEDIA EPIC",
      detail: "Platform Hiburan #1 Khas Kepada Bakat Tempatan untuk Menyerlah",
    },
    swiperbox_seven:{
      title: "3 Bersama, Kita Bersatu",
      highlight: "18hb Mac, 2021",
      detail: "Detik Penting Ulang Tahun EpicWin"
    },
    swiperbox_eight:{
      title: "KOMUNITI EPICWIN PERLUMU",
      highlight: "KOMUNITI",
      detail: "Sertailah komuniti petaruh yang ramah mesra dan saling menghulurkan bantuan bagaikan sebuah keluarga",
      mobile: "KOMUNITI"
    },
  },
  amount_receive: "Jumlah yg. Diterima",
  active_player: "Jumlah PEMAIN AKTIF",
  affiliate_code: "Kod Sekutu ",
  admin: "Admin",
  admin_open: "jika anda menghadapi masalah menerima kod TAC",
  affiliateUI: {
    title: "Program Affiliate",
    title1: "Mengapa Sertai kami?",
    detail: "Cashback up to 50%",
    detail1: "Keuntungan seumur hidup",
    detail2: "Bayaran terjamin",
    button: "Sertai kami & Earn menjana Pulangan Tunai Segera",
    step:{
      title: "Bagaimana melakukannya",
      detail: "Formula perolehan mudah saja. Kami memberikan anda pautan penjejakan yang unik untuk membuat promosi dan tugasmu selesai.",
      step1: "Mendaftar",
      step2: "Mulai promosi dengan pautan penjejakan",
      step3: "Peroleh Pulangan Tunai tanpa had"
    },
    cashback:{
      title: "Struktur Pulangan Tunai",
      detail: "Pulangan Tunai adalah berasaskan pada jumlah menang/kalah ialah hasil pertaruhan bersih yang dijana oleh pemain yang mendaftar diri melalui pautan penjejakanmu.",
      one: "Hasil Pertaruhan Bersih ≤ RM 20,000",
      two: "Hasil Pertaruhan Bersih  RM 20,001 - RM 40,000",
      three: "Hasil Pertaruhan Bersih  RM 40,001 - RM 60,000",
      four: "Hasil Pertaruhan Bersih ≥ RM 60,001",
      button: "Sertai kami & Earn menjana Pulangan Tunai Segera"
    }
  },
  artist:{
    title: "Selebriti EPIC",
    mainintro1: "EpicWin dengan Gembiranya Memperkenalkan Danny Chan kepada Anda.",
    maindesc1: "<strong>BINTANG HANDALAN dari HONG KONG</strong> yang menjadi Duta Jenama EpicWin 2020",
    artist_content1: "Sebagai seorang pelakon Hong Kong yg. Masyhur, <strong>Danny Chan</strong> dikenali ramai dgn. wajahnya yg. mirip dgn. Bruce Lee, serta wataknya dlm. Ip Man dan Kung Fu Hustle!",
    watch_button1: "Tontoni Video Danny Chan",
    mainintro2: "Kami juga berasa bangga memperkenalkan 3 org. Selebriti EPIC dari Malaysia",
    maindesc2: "3P, Penstrim YouTube yang Terkemuka, Leona Chin, Ratu Gerakan Hanyut dan Rachel B, Pemacu Lagu yang Terhebat di dunia dari Malaysia!",
    artist_content2: "Gerakan epik <strong>Rachel B</strong>- prestasi bertenaga yang digemari ramai menjadinya salah seorang Pemacu Lagu yang Terhangat di Malaysia!",
    watch_button2: "Tontoni Video Rachel B.",
    artist_content3: "Penggemar YouTube barangkali mengenali wajah mereka yang digemari ramai dengan penstriman kandungan video ujikaji yang melucukan dan kreatif!",
    watch_button3: "Tontoni Video ThreeeP",
    artist_content4: "<strong>Leona Chin</strong>, wanita sebelah pintu terunggul yang dibumbui dengan keberanian, kelajuan dan keterujaan - terkenal sebagai tokoh wanita yang menerima anugerah perlumbaan kerata sukan!",
    watch_button4: "Tontoni Video Leona Chin",
  },
  attachment: "Lampiran",

  bank_accname: "Pemegang Akaun",
  bank_accno: "Nombor Akaun",
  bank_name: "Nama Bank",
  bank_detail: "Butiran Bank",
  bet_history: "Sejarah Taruhan",
  bank_account: "Akaun Bank",
  better_luck: "Lebih bertuah lain kali!",
  birthday: "Harijadi",
  bonus_details: "Butiran Bonus",
  before_balance: "Baki Sebelumnya",
  bonus_value: "Nilai Bonus",
  bonus: "Bonus",
  brand: {
    vision: "Visi Jenama",
    vision_desc: "Mencipta dunia maya tanpa perdayaan. Menjadi pencipta slot jackpot dengan pembayaran yang terpantas di dunia",
    purpose: "Misi Jenama",
    purpose_desc: "Merealisasikan impian jackpot setiap petaruh dengan membanteras segala tipu daya kini."
  },
  back: "Kembali",
  bonus_welcome: "Welcome Bonus",
  bonus_referral: "Bonus Rujukan",

  cdm: "MESIN DEPOSIT TUNAI (MDT)",
  counter: "KAUNTER",
  cancel: "Batal",
  change_password: "Tukar Kata Laluan",
  confirm_password: "Pengesahan Kata Laluan",
  close: "Tutup",
  claim: "Tuntut",
  claim_now: "Tuntut Sekarang Juga",
  current_balance: "Baki Sedia Ada",
  cash_deposit: "Deposit Tunai",
  contact_for_bank: "Sila hubungi kami melalui EpicWin Livechat",
  congratulations: "Tahniah!",
  contact_number: "Nombor Telefon",
  claim_rewards: "Tuntut Pemberian",
  cash_value: "Nilai Tunai",
  customer_review: "Ulasan EPIC",
  claim_offer: "Tuntut tawaran",
  custom_description: {
    free_spin: "RM 50-RM 99 + 1 Tiket Jackpot",
    free_spin2: "RM 100-RM 199 + 3 Tiket Jackpot",
    free_spin3: "RM 200-RM 499 + 7 Tiket Jackpot",
    free_spin4: "RM 500-RM 999 + 10 Tiket Jackpot",
    free_spin5: "≥RM 1000 + 13 Tiket Jackpot",
    free_spin6: "RM 5000-RM 9999 + 25 Kali Putaran Percuma Premium",
    free_spin7: "≥RM 10000 + 50 Kali Putaran Percuma Premium",
    free_spin8: "≥RM 10000 + 100 Kali Putaran Percuma Premium dan 14 Tiket Jackpot",
    get_freespin: "Anda menerima  {amount} Kali Putaran Percuma",
    get_premiumspin: "Anda menerima {amount} Kali Putaran Premium Percuma",
    get_freespin_ticket: "Anda menerima {amount} Kali Putaran Percuma dan {t_amount} Tiket Cabutan Bertuah",
    get_premiumspin_ticket: "Anda menerima {amount} Kali Putaran Percuma Premium dan {t_amount} Tiket Cabutan Bertuah",
    get_jackpot_ticket: "Anda akan menerima {amount} Tiket Jackpot",
    get_euroticket: "Anda akan menerima {amount} Tiket Piala Euro",
    comment_placeholder: "Tinggalkan pendapatmu",
    review_header: "Memperkenalkan seorang rakan mainan untuk menerima pemberian ",
    refer_info: "Memperoleh <strong> 8 kali Putaran Percuma</strong>Setiap kali jumlah deposit yang dilakukan oleh rakan mainan yang dirujuk olehmu terkumpul sehingga RM 30",
    review_text: "Nombor telefon mudah alih rakanmu:",
    review_complete_header: "Terima kasih kerana menyebarkan Getaran Tenaga Positif!",
    review_complete_text: "Kami akan menggunakannya untuk menambahbaik kualiti produk.",
    home_title: "BAYARAN TERJAMIN DALAM 1-MIN",
    home_description: "Bayaran Terpantas #1 digerakkan oleh Pembuat Slots",
    home_title2: "CEPUMAS CEPAT",
    home_description2: "Pembinaan Platform Ganjaran Cepumas Tercepat",
    home_title3: "SLOTS SUPERSTAR",
    home_description3: "Ciptaan Mainan Kami Berasal Dari: DC, Marvel, Disney dan 20th Century Fox",
    home_title4: "TANPA EJEN",
    home_description4: "Kami adalah jenama langsung bekalan tanpa orang tengah"
  },
  count: "Bilangan Pemain",
  click_here: "Klik Sini",
  change: "Tukar",
  change_content:{
    mobile_title: "CHANGE TO WIN, CHANGE TO EPIC",
    title: "MENGAPAKAH ANDA MENUKAR KE EPICWIN?",
    description: "EpicWin menginspirasikan keghairahan dalam mencipta Slots SuperStar, bergabung dengan jenama-jenama termasyhur dalam industri perfileman seperti Disney, Marvel & DC Comics. Membawakan ganjaran cepusan dalam talian yang tertinggi di Malaysia. EpicWin adalah pembuat slots yang pertama dalam industri menerima tawaran langsung TANPA EJEN. Nikmatilah bayaran terpantas yang dijamin dalam masa 1-MIN oleh EpicWin.",
    check_story: "KISAH BERKENAAN",
    step: "LANGKAH",
    step1_title: "Tukar Ke EpicWin",
    step1_description: "Beralih dari jenama lain ",
    step1_description1: "ke EpicWin",
    step2_title: "Rekod sebuah video",
    step2_description: "Rekodkan sebuah video",
    step2_description1: "dan beritahu kami mengapakah anda menukar ke EpicWin",
    step3_title: "Dapatkan Ganjaran",
    step3_description: "Terbitkan video anda di Facebook, ",
    step3_description1: "hantarkan URL tersebut kepada kami dan menang hadiah istimewa!",
    video_title: "Tukar ke Epic, Menangi Hadiah Istimewa",
    small_label: "URL Video Facebook",
    placeholder: "Sila isi url video Facebook anda",
    tnc1: "Tempoh Kempen: 1hb Dis 2020 hingga 31hb Januari 2021.",
    tnc2: "Ikuti langkah-langkah tersebut di atas dan hantarkan pautan (URL) video anda untuk penyertaan.",
    tnc3: "Ganjaran Putaran Percuma EpicWin akan diberikan dalam tempoh 24 jam selepas penghantaran pautan (URL) video disahkan.",
    tnc4: "Setiap peserta hanya dibenarkan untuk menang sekali sahaja sepanjang tempoh kempen.",
    mobile_desc: "EpicWin menginspirasikan keghairahan dalam mencipta Slots SuperStar, bergabung dengan jenama-jenama termasyhur dalam industri perfileman seperti Disney, Marvel & DC Comics.",
    mobile_desc1: "Membawakan ganjaran Cepumas dalam talian yang paling lumayan di Malaysia.",
    mobile_desc2: "Pembuat slots #1 dalam industri menerima tawaran langsung TANPA EJEN, jaminan bayaran terpantas dalam masa 1-MIN oleh EpicWin."
  },
  coupon: "Kupon",

  deposit: "Deposit",
  deposit_enter: "Sila masukkan jumlah deposit",
  deposit_method: "Kaedah Deposit",
  deposit_method_select: "Sila pilihkan kaedah deposit",
  deposit_reminder: "Saya telah membaca, memahami dan menyetujui segala yang telah ditetapkan ",
  deposit_reminder_two: " termasuk bonus dan/atau syarat pengeluaran",
  download: "Muat Turun",
  download_android: "Versi Android",
  download_ios: "Versi iOS",
  date: "Tarikh",
  done: "Selesai",
  deposit_now: "Deposit Sekarang Juga",
  description: "Deskripsi",
  download_1: "Jom sertailah sekarang dan menjadi salah seorang daripada ahli keluarga EPIC",
  download_2: "Perjalanan EPIC anda bermula dari sini!",
  deposit_tnc: "Deposit - Tiket Jackpot Percuma",
  developer_response: "Maklum Balas Penjadi",
  daily_update: "Kemas Kini Harian",
  downloadgame: "Muat Turun Game",
  duitnow:{
    desc1: "Deposit Minimum: ",
    desc1_1: "RM30",
    desc2: "Simpan resit pemindahan",
    desc3: "Mesej kami via sistem Bual Langsung untuk menerima token taruhan",
    desc4: "Nikmati keseronikan pertaruhan dalam mainan kami!"
  },
  dailycheckin: "Semakan Harian",
  deposit_topten: "10 Bilangan Deposit Tertinggi",
  demoplay: "Main Demo",
  deposit_page:{
    reminder1: "Balance must be below RM1 before deposit, or previous bonus rules will apply",
    reminder2: "Don’t use saved QR codes. Please use only the latest displayed QR code"
  },

  email: "E-mel",
  enter_bank_accname: "Sila masukkan Nama Pemegang Akaun Bank",
  enter_bank_accno: "Sila masukkan Nombor Akaun Bank",
  eta: "Tempoh Kelulusan Teranggar",
  epic_production: "EPIC Production",
  expiry_date: "Tarikh Berkuatkuasa Terakhir",

  female: "Wanita",
  failed: "Gagal",
  forgot_password: "Terlupa Kata Laluan?",
  faq: "SOALAN LAZIM DITANYA",
  footer: {
    title: "Seruan kepada semua VIP: Penggelek tinggi dan pemain bertaruh untuk hiburan; main hanya untuk bersenang-senang dan pencari keseronokan. Bagi sesiapa yang mencari kasino dalam talian BERKEPECAYAAN, EpicWin adalah petunjuk arah untukmu.",
    description: "Selamat datang ke EpicWin, online slot games in Malaysia yang paling trendi, menawarkan permainan percuma, free credit claim selepas pendaftaran (just register to claim free credit), pemberian bonus dan akses kepada Malaysia online slot games yang terbaik.",
    description1: "Tunggu! Sebelum anda memulakan perjalanan menuju ke kemenangan besar, jangan lupa \"claim free credit link\" anda, yang merupakan keistimewaan anda sebagai ahli EpicWin baru yang membolehkan anda menikmati free credit slot games yang terbaik di free credit casino yang unik ini. Daftar sekarang untuk claim free credit dan mulakan perjalanan anda menuju ke kemenangan besar pada hari ini! ",
    description2: "Daftar untuk claim free credit di EpicWin dan cuba Malaysia online slot games yang terbaik. Menang besar dengan EpicWin, kasino dalam talian terbaik di Malaysia dengan free credit, no deposit!",
    description3: "EpicWin ialah online slot Malaysia terunggul yang menawarkan faedah hebat seperti game slot free credit. EpicWin menjadikan impian anda menjadi kenyataan — daftar secara percuma, claim free credit dan mulakan perjalanan anda menuju ke kemenangan EPIK sekarang!",
  },
  for_android: "Untuk Android",
  for_ios: "Untuk iOS",
  find_out: "Ketahui lebih lanjut",
  file_choose: "Pilih Fail",
  file_upload: "Muat Naik Fail",
  file_requirement: "Saiz file tidak boleh melebihi daripada 200kb dan mestilah dalam format png, jpg atau jpeg",
  full_name: "Nama Penuh",
  fill_stars: "Sila berikan perkadaran anda sebelum menyusul langkah seterusnya",
  full_phone: "Phone Number (手机号码, Nombor Telefon)",
  full_referral: "Referral Code (邀友代码, Kod Pengajakan)",
  fish:"Fishing",

  gender: "Jantina",
  game_play: "Game Play",
  game: "Game",

  hi: "Hi, ",
  has_won: "Berjaya memenangi",
  has_won_rate: " kadar kemenangan",
  has_withdraw: "Telah mengeluarkan",
  has_deposit: "Telah mendepositkan",
  homepage: {
    header1: "SLOT ASAL NOVOMATIC",
    desc1: "Nikmati slot terbaik untuk dimainkan dari pemimpin pasaran!",
    header2: "BOD PEMAIN UTAMA",
    desc2: "Bermain dan mempertanding dengan rakanmu dalam bod pemain utama dan peraduan bertema slot!",
    header3: "TAWARAN BONUS TERSYOK!",
    desc3: "Nikmati pelbagai jesnis bonus dan promosi!",
    header4: "KELAB VIP & PROGRAM KESETIAAN",
    desc4: "Marilah membentangkan permaidani merah ! Sebagai seorang VIP anda akan dilayani dengan manfaat tidak terkira banyaknya."
  },
  hourly_update: "Kemas Kini Setiap Jam",
  hot_movie: "Filem Popular",

  ios: "iOS",

  jackpot: "Cepumas",

  leaderboard_title: "15 ORANG CALON TERATAS DGN JUMLAH PUTARAN TERBANYAK",
  login: "Login",
  logout: "Log Keluar",
  login_now: "Log Masuk Sekarang",
  lucky_spin: "Putaran Bertuah untuk kemenangan sehingga RM{value}",
  latest_transactions: "Transaksi Terkini",
  lucky_wheel: "Roda Bertuah",
  loyalty_points: "Mata Kesetiaan",
  last_4_digits: "4 angka terakhir bagi nombor telefon",
  last_login: "Log Masuk Terakhir",
  lang_en: "Inggeris",
  lang_zh: "Cina",
  lang_my: "Melayu",
  luckydraw_announcement: "Anda Akan Menerima Tiket Cabutan Bertuah Selepas Deposit Berjaya Dilakukan<br>Terus Bersama Kami Untuk Cabutan Bertuah Langsung<br>19hb April 2021, 7.30ptg",
  language:{
    en: 'en',
    zh: 'zh-cn',
    my: 'ms'
  },
  later: "Nanti",
  leaderboard: "Leaderboard",
  live:"Live",
  livecasino:"Kasino Live",
  live_trans: "Transaksi Langsung",
  lottery: "Loteri",

  male: "Lelaki",
  mobile: "Mudah Alih",
  minigames: "Permainan Mini",
  method: "Kaedah",
  min: "Min.",
  min_amount: "Jumlah Min.",
  monthly_update: "Kemas Kini Bulanan",
  movies: "Filem",
  movie_watch: "Tonton Sekarang",
  marquee:{
    notice: "Peringatan:",
    announcement: " Jika tidak dapat mengakses {url}, sila gunakan <b style='color:#FFC000'>www.epicwin.asia</b> untuk bermain tanpa gangguan! 💰100% GUARANTEED CUCI !"
  },
  more_info: "Info Lanjut",
  minigame:"Minigame",

  name: "Nama",
  next: "Seterusnya",
  new_password: "Kata Laluan Baru",
  no_account_yet: "Masih Tiada Akaun?",
  no_win: "Anda tidak memenangi apapun dalam pusingan kali ini :(",
  nickname: "Nama Panggilan",
  next_update_time: "Waktu Kemas Kini Seterusnya",
  no_bonus_found: "Tiada butiran bonus dapat dicari",
  no_adjustment_found: "Tiada butiran penyesuaian dapat dicari",
  no_new_gifts: "Tiada ganjaran baru",
  no: "No.",
  no_contact: "Tiada Nombor Telefon tersedia!",
  no_new_message: "Tiada mesej baru",
  newsletter: "Saya ingin ketahui ttg tawaran & promosi terkini melalui e-mel, mesej atau hantaran",
  news: "Berita",

  offical_team: "Pasukan Rasmi",
  online: "DALAM TALIAN",
  online_banking: "Perbankan dalam Talian",
  online_banking_set: "Perbankan dalam Talian ({bank})",
  option: "Pilihan {0}",
  optional: "Pilihan",
  old_password: "Kata Laluan Lama",
  ok: "Ok",
  current_password: "Kata Laluan Semasa",
  operator_bank_list: "Senarai Pengoperasi Bank",
  promotion_selected: "Promosi yang dipilih",

  pending: "Tertunggak",
  play_now: "Bertaruh Sekarang Juga",
  partner: "Rakan Kerjasama",
  partner_short: "Partner",
  partner_title: "Rakan Eksklusif EpicWin:",
  password: "Kata Laluan",
  password_signup: "Cipta Kata Laluan",
  phone_number: "Nombor Telefon",
  promotion: "Promosi",
  promotions: "Promosi",
  promotion_select: "Sila pilihkan Promosi / Tiada Promosi",
  profile: "Profil",
  privacy_policy: "Dasar Peribadi",
  privacy_statement: "Penyata Peribadi",
  password_tips:"Mencipta kata laluan sendiri. Contoh: Tckqp123.<br /> Antara 6-20 aksara dengan kombinasi angka dan huruf",
  phone_tips: "HANYA nombor telefon sah sahaja Cth: 0109471427, tidak perlu berselang",
  problem_contact:"Jika anda menghadapi masalah dalam menerima kod, sila hubungi kami melalui Live Chat.",
  reset_tips: "Sila masukkan 4 angka terakhir bagi nombor telefon anda",
  prev: "Sebelumnya",
  please_select: "Sila Pilihkan",
  please_select_bank: "Sila Pilihkan Bank",
  please_select_payment: "Sila Pilih Kaedah Pembayaran",
  progress : "Kemajuan",
  promotion_bonus: "Bonus Promosi",
  promotion_details: "Butiran Promosi",
  phone_no_reminder_recipient: "Sila masukkan nombor telefon penerima",
  phone_recipient_same: "Nombor telefon penerima tidak boleh sama dengan pengirim",
  promo_select: "Sila Pilihkan Promosi",
  promo_none: "Tiada Promosi",
  promo_text:{
    promo1: {
      title1: "Deposit:",
      details1: "RM 30",
      title2: "Deposit Permulaan:",
      details2: "RM 36",
      title3: "Jumlah Pengeluaran:",
      details3: "RM 108"
    },
    promo2: {
      title1: "Deposit:",
      details1: "RM 10",
      title2: "Deposit Permulaan:",
      details2: "RM 20",
      title3: "Jumlah Pengeluaran:",
      details3: "RM 50"
    },
    promo3: {
      title1: "Deposit:",
      details1: "RM 10",
      title2: "Bonus:",
      details2: "RM 12",
      title3: "Jumlah Pengeluaran:",
      details3: "RM 88"
    },
    promo4: {
      title1: "Deposit:",
      details1: "RM 10",
      title2: "Deposit Permulaan:",
      details2: "RM 11",
      title3: "Jumlah Pengeluaran:",
      details3: "RM 33"
    },
    promo5: {
      title1: "Deposit:",
      details1: "RM 50",
      title2: "Deposit Permulaan:",
      details2: "RM 62.5",
      title3: "Jumlah Pengeluaran:",
      details3: "RM 187.5"
    },
    promo6: {
      title1: "Attendance:",
      details1: "5 hari",
      title2: "Deposit Terkumpul:",
      details2: "MYR 150",
      title3: "Bonus:",
      details3: "MYR 10"
    },
    promo7: {
      title1: "Kekerapan Tuntutan:",
      details1: "Sekali Sehari",
      title2: "Peratusan Dapat:",
      details2: "10%",
      title3: "Syarat Pengeluaran:",
      details3: "x 1"
    },
    promo08: {
      title1: "Deposit:",
      details1: "RM 50",
      title2: "Deposit Permulaan:",
      details2: "RM 57.5",
      title3: "Jumlah Pengeluaran:",
      details3: "RM 172.5"
    },
    promo9: {
      title1: "Bonus:",
      details1: "MYR 20",
      title2: "Syarat Pengeluaran: ",
      details2: "Winover x3",
      title3: "Angpao:",
      details3: "MYR 8"
    },
    promo10: {
      title1: "Bonus:",
      details1: "MYR 20",
      title2: "Jumlah Akumulasi",
      details2: "MYR 150"
    },
    promo11: {
      title1: "Deposit:",
      details1: "MYR 30",
      title2: "Bonus",
      details2: "MYR 36",
      title3: "Syarat Pengeluaran: ",
      details3: "Turnover x30",
    },
    promo12:{
      title1: "Deposit:",
      details1: "MYR 30",
      title2: "Bonus",
      details2: "MYR 4.5",
      title3: "Syarat Pengeluaran: ",
      details3: "Turnover x20",
    },
    promo13:{
      title1: "Deposit:",
      details1: "MYR 50",
      title2: "Bonus",
      details2: "MYR 12.5",
      title3: "Syarat Pengeluaran: ",
      details3: "Turnover x20",
    },
    promo14:{
      title1: "Deposit:",
      details1: "MYR 1111",
      title2: "Bonus",
      details2: "MYR 33 + Menang 1111",
    },
    promo15:{
      title1: "Bonus:",
      details1: "MYR 20 + 30",
      title2: "Jumlah Akumulasi",
      details2: "MYR 500",
    },
    promo16:{
      title1: "Angpao:",
      details1: "MYR 500",
      title2: "Winover",
      details2: "x10",
    },
    promo17:{
      title1: "Angpao:",
      details1: "MYR 33",
      title2: "Winover",
      details2: "x4",
    },
  },
  promo_detail:{
    general_tnc: "<p>TERMA & SYARAT AM</p><ul><li>Pengeluaran terhad kepada 5 kali sehari sahaja.</li><li>EpicWin memiliki hak untuk menamatkan akaun ahli tanpa notis awal jika berlaku pelanggaran terma & syarat</li><li>Jumlah pengeluaran minimum adalah RM10</li></ul>",
    general_tnc_casino:"<p>GENERAL TERMS &amp; CONDITIONS</p><ul><li>TARIK BALIK Duit KEMENANGAN dan pulangkan DEPOSIT jika pemain melanggar T&C</li><li>Bonus dan baki kemenangan akan luput selepas 30 hari (Tujuan keselamatan)</li><li><span class='text-danger'>Live Casino CANNOT play - Sports / Blackjack 21 / Texas Hold'em /（ Not Include Sport Book, Fishing , RNG table ,  Slot Game )</span></li></ul>",
    promo1:{
      title: "20% Bonus Deposit Pertama (Setiap Hari dari Isnin hingga Jumaat)",
      table:{
        header1: "Amaun Deposit",
        header2: "Amaun Bonus",
        header3: "Amaun Permulaan",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Minimum",
        header6: "Pengeluaran Maksimum(6x Deposit)",
        withdraw_req: "Winover x3"
      },
      tnc1: "Deposit minimum adalah RM30 dan bonus maksimum adalah RM30",
      tnc2: "Promosi sah untuk Epicwin & MegaH5 dan boleh dituntut sekali (1) SAHAJA pada setiap hari dari ISNIN hingga JUMAAT",
      tnc3: "Untuk pengeluaran, syarat Winover adalah 3x (amaun deposit + bonus).",
      tnc4: "Sebarang baki kredit akan dikeluarkan daripada akaun pemain selepas pengeluaran",
    },
    promo2:{
      title: "Bonus Selamat Datang Tambah Nilai Pin 100% - Eksklusif untuk Permainan EpicWin & Mega H5",
      table:{
        header1: "Amaun Deposit",
        header2: "Amaun Bonus",
        header3: "Amaun Permulaan",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Minimum & Maksimum  (5x Deposit)",
        withdraw_req: "Turnover x10"
      },
      tnc1: "Deposit minimum adalah RM10 dan bonus maksimum adalah RM50",
      tnc2: "Promosi hanya sah untuk deposit pertama ahli baharu pada permainan EpicWin dan Mega H5 sahaja",
      tnc3: "Untuk pengeluaran, syarat Turnover adalah 10x (amaun deposit + bonus).",
      tnc4: "Jumlah pengeluaran maksimum untuk promosi ini hanya boleh dilakukan sekali untuk maksimum 5x amaun deposit. Sebarang baki kredit akan dikeluarkan daripada akaun pemain selepas pengeluaran",
      tnc5: "Sebarang pertaruhan atas pengendali yang lain akan menyebabkan pembatalan kemenangan"
    },
    promo3:{
      title:"Welcome Bonus 120%",
      table0:{
        header1: "Welcome Bonus 120%",
        header2: "Deposit Minimum",
        header3: "Maximum Bonus Payout",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Maksimum",
        row1: "1st Deposit"
      },
      table:{
        header1: "Amaun Deposit",
        header2: "Amaun Bonus",
        header3: "Amaun Permulaan",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Minimum",
        withdraw_req: "Winover x4",
      },
      content1: "Contoh: ",
      content2: "<span class='text-danger'>Deposit</span> 100 <span class='text-danger'>+ bonus</span> 120 <span class='text-danger'>= 220</span>",
      content3: "Pengeluaran minimum:",
      content4: "220 x 4 = 880",
      content5: "Pengeluaran maksimum:",
      content6: "100 x 10 = 1000",
      content7: "Sebarang baki kredit yang tinggal selepas pengeluaran akan dikeluarkan daripada akaun pemain.",
      tnc1: "Deposit minimum untuk promosi ini ialah RM10, dengan bonus maksimum RM120.",
      tnc2: "Promosi ini hanya tersedia untuk ahli baharu yang membuat deposit pertama di EpicWin.",
      tnc3: "Bonus ini sah untuk SEMUA PERMAINAN SLOT.",
      tnc4: "Pengeluaran maksimum adalah 10x JUMLAH DEPOSIT.",
      tnc5: "Promosi ini tidak terpakai untuk permainan Kasino Langsung, Sportsbook, dan permainan Memancing.",
      tnc6: "Promosi ini tidak boleh digabungkan dengan promosi lain melainkan dinyatakan sebaliknya.",
      tnc7: "Sebarang baki kredit yang tinggal selepas pengeluaran akan dikeluarkan daripada akaun pemain.",
      tnc8: "Semua bonus dan kemenangan akan dibatalkan jika ahli tidak memenuhi keperluan turnover dalam tempoh 30 hari selepas bonus diberikan.",
      tnc9: "Promosi ini hanya boleh dituntut sekali oleh pemain baharu sebagai tawaran alu-aluan.",
      tnc10: "Untuk menuntut bonus ini, sila hubungi pasukan sokongan Live Chat kami."
    },
    promo4:{
      title:"10% Bonus Tambah Nilai Tanpa Had - Untuk SEMUA Pemain",
      table:{
        header1: "Amaun Deposit",
        header2: "Amaun Bonus",
        header3: "Amaun Permulaan",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Minimum",
        header6: "Pengeluaran Maksimum",
        withdraw_req: "Winover x3"
      },
      tnc1: "Deposit minimum adalah RM10 dan bonus maksimum adalah RM50",
      tnc2: "Ahli boleh menuntut promosi ini pada SETIAP deposit dan promosi ini sah untuk SEMUA slot.",
      tnc3: "Untuk pengeluaran, syarat Winover adalah 3x (amaun deposit + bonus).",
      tnc4: "Sebarang baki kredit akan dikeluarkan daripada akaun pemain selepas pengeluaran",
    },
    promo5:{
      title:"25% Bonus Hujung Minggu (Sabtu & Ahad)",
      table:{
        header1: "Amaun Deposit",
        header2: "Amaun Bonus",
        header3: "Amaun Permulaan",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Minimum",
        header6: "Pengeluaran Maksimum (8x Deposit)",
        withdraw_req: "Winover x3"
      },
      tnc1: "Deposit minimum adalah RM50 dan bonus maksimum adalah RM37.5",
      tnc2: "Promosi sah untuk Epicwin & MegaH5 dan ahli boleh menuntut promosi ini SEKALI sahaja pada hari Sabtu dan Ahad",
      tnc3: "Untuk pengeluaran, syarat Winover adalah 3x (amaun deposit + bonus).",
      tnc4: "Sebarang baki kredit akan dikeluarkan daripada akaun pemain selepas pengeluaran",
    },
    promo6:{
      title:"BONUS KEHADIRAN SEMPURNA",
      table:{
        header1: "Attendance",
        header2: "Deposit Terkumpul",
        header3: "Bonus",
        header4: "Extra",
        attendance: "Terkumpul 5 hari dalam 30 hari",
        accumulated: "MYR {amount} dan ke atas"
      },
      tnc1: "Untuk menuntut bonus ini, pemain mesti membuat deposit terkumpul sekurang-kurangnya RM150 dalam mana-mana 5 hari dalam tempoh 30 hari.",
      tnc2: "Bonus akhir akan merujuk kepada jadual bonus.",
      tnc3: "Pastikan baki dompet anda kurang daripada RM0.50 untuk menuntut bonus cek harian anda. Jika tidak, baki akan terikat dengan T&C bonus yang dituntut.",
      tnc4: "Selepas mengumpul bonus ini, sila hubungi Live Chat kami untuk menuntut 10X Putaran Percuma.",
      tnc5: "Jumlah pengeluaran maksimum untuk promosi ini hanya boleh dilakukan sekali dan dihadkan kepada 5x (jumlah bonus).",
      tnc6: "Bonus ini tidak boleh dituntut bersama dengan deposit dan promosi lain kecuali dinyatakan sebaliknya.", 
      tnc7: "Baki kredit yang tinggal selepas pengeluaran akan dikeluarkan daripada akaun pemain.",
      tnc8: "Untuk semua slot game",
    },
    promo7:{
      title:"PROGRAM RUJUKAN RAKAN",
      table:{
        header1: "Kekerapan Tuntutan",
        header2: "Komisen",
        header3: "Peratusan Dapat",
        header4: "Syarat Pengeluaran",
        details1: "Deposit rakan yang dirujuk",
        details2: "Turnover Downline",
        details3: "10%"
      },
      tnc1: "Dapatkan 10% cashback atau maksimum sehingga RM20 untuk deposit yang dibuat oleh rakan yang dirujuk baru",
      tnc2: "Bonus cashback 10% sah apabila rakan yang dirujuk deposit tanpa promosi",
      tnc3: "Keperluan tuntutan adalah komisen RM5 dan ke atas",
    },
    promo8:{
      title:"15% Bonus Hujung Minggu (Sabtu & Ahad)",
      table:{
        header1: "Amaun Deposit",
        header2: "Amaun Bonus",
        header3: "Amaun Permulaan",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Minimum",
        header6: "Pengeluaran Maksimum (8x Deposit)",
        withdraw_req: "Winover x3"
      },
      tnc1: "Deposit minimum adalah RM50 dan bonus maksimum adalah RM22.5",
      tnc2: "Promosi sah untuk semua slots KECUALI Epicwin & MegaH5 dan ahli boleh menuntut promosi ini SEKALI sahaja pada hari Sabtu dan Ahad",
      tnc3: "Untuk pengeluaran, syarat Winover adalah 3x (amaun deposit + bonus).",
      tnc4: "Sebarang baki kredit akan dikeluarkan daripada akaun pemain selepas pengeluaran",
    },
    promo9:{
      title: "520 Special",
      table:{
        header1: "Deposit Terkumpul",
        header2: "Bonus",
        header3: "Syarat Pengeluaran",
        header4: "Pengeluaran Maksimum",
        header5: "Pengeluaran Minimum",
        header6: "Pengeluaran Maksimum",
        withdraw_req: "Winover x3"
      },
      tnc1: "Tempoh acara 7 - 20 May 2024",
      tnc2: "Depo sejumlah MYR 520 & untuk dijamin mendapat Angpao MYR 20",
      tnc3: "Tambahan 10 pemain bertuah akan mendapat MYR 500, pengumuman pemenang pada 21 Mei 2024 dlm <a href='https://web.telegram.org/k/#@epicwinspin' target='_blank'>EpicWin Telegram group</a> (tarikh tuntutan: 21 - 24 Mei 2024)",
      tnc4: "Untuk menuntut Angpao, sila hubungi LiveChat kami",
      tnc5: "Min Winover x3",
      tnc6: "Dihadkan pada MYR 500",
      tnc7: "Hanya untuk permainan EpicWin & MegaH5",
      tnc8: "Hanya untuk permainan EpicWin & MegaH5 sahaja"
    },
    promo10:{
      title: "Birthday Bonus",
      table:{
        header1: "Deposit Terkumpul",
        header2: "Min. Claim",
        header3: "Max. Claim",
        header4: "Syarat Pengeluaran",
        header5: "Pengeluaran Maksimum",
        detail1: "15 atau keatas",
        withdraw_req: "Winover x5"
      },
      tnc1: "Kumpul jumlah deposit sebanyak MYR 150 setiap bulan untuk menuntut bonus ini pada tarikh pendaftaran anda.",
      tnc2: "Bonus ini tidak boleh digabungkan dengan bonus lain.",
      tnc3: "Ulang Tahun Epic: Sila rujuk kepada tarikh pendaftaran di bawah profil ID, BUKAN tarikh lahir pada IC.",
      tnc4: "Untuk menuntut bonus ini, sila hubungi LiveChat.",
      tnc5: "Boleh dituntut sekali setiap bulan.",
      tnc6: "Boleh dituntut 12 kali setiap tahun.",
      tnc7: "Hanya boleh bermain permainan EpicWin dan MegaH5.",
      tnc8: "Keperluan pengeluaran: Min & Max kemenangan x4 (MYR 80)."
    },
    promo11:{
      title: "Live Casino Welcome Bonus 120%",
      tnc1: "Pemain hanya boleh menuntut promosi sekali sahaja. Untuk layak, pemain perlu membuat deposit minimum sebanyak MYR 30, Bonus Maksimum RM 120.",
      tnc2: {
        sub0: "Perhitungan jumlah deposit dan bonus adalah seperti berikut.  ",
        sub1: "Contoh: ",
        sub2: "i. Deposit Pertama = MYR 100  ",
        sub3: "ii. Bonus = Deposit Pertama MYR 100 x 120% = MYR 120  ",
        sub4: "iii. Persyaratan Putaran = (100 + 120) x 30 = MYR 6600"
      },
      tnc3: "Keperluan putaran untuk promosi ini adalah sebanyak x30 kali dan Maksimum boleh dikeluarkan adalah (Deposit + Bonus) x 10.",
    },
    promo12:{
      title: "Live Casino WEEKDAYS 15% FIRST DEPOSIT BONUS",
      tnc1: "Pemain boleh menuntut promosi sekali sehari semasa hari biasa. Untuk layak, pemain perlu membuat deposit minimum sebanyak MYR 30, Bonus Maksimum RM 15.",
      tnc2: {
        sub0: "Perhitungan jumlah deposit dan bonus adalah seperti berikut.  ",
        sub1: "Contoh: ",
        sub2: "i. Deposit Pertama = MYR 100 ",
        sub3: "ii. Bonus = Deposit Pertama MYR 100 x 15% = MYR 15",
        sub4: "iii. Persyaratan Putaran = (100 + 15) x 20 = MYR 2300"
      },
      tnc3: "Keperluan putaran untuk promosi ini adalah sebanyak x20 kali dan Maksimum boleh dikeluarkan adalah RM10,000.00.",
    },
    promo13:{
      title: "Live Casino WEEKENDS 25% DEPOSIT BONUS",
      tnc1: "Pemain boleh menuntut promosi sekali sehari semasa hujung minggu. Untuk layak, pemain perlu membuat deposit minimum sebanyak MYR 50, Bonus Maksimum RM 37.50.",
      tnc2: {
        sub0: "Perhitungan jumlah deposit dan bonus adalah seperti berikut.  ",
        sub1: "Contoh:",
        sub2: "i. Deposit Pertama = MYR 100 ",
        sub3: "ii. Bonus = Deposit Pertama MYR 100 x 25% = MYR 25",
        sub4: "iii. Persyaratan Putaran = (100 + 25) x 20 = MYR 2,500"
      },
      tnc3: "Keperluan putaran untuk promosi ini adalah sebanyak x20 kali dan Maksimum boleh dikeluarkan adalah RM10,000.00.",
      tnc4: "Untuk layak mendapat promosi ini, pemain boleh mengklik promosi tersebut di halaman deposit."
    },
    promo14:{
      title: "11.11 Epic Promo",
      tnc1: "Deposit sebanyak RM1,111 untuk dapatkan Angpow RM33 yang dijamin semasa tempoh promosi ini. 11 pemenang bertuah akan dipilih untuk memenangi RM1,111. Pemenang bertuah akan diumumkan pada 12 November di kumpulan Telegram EpicWin. (Tarikh tuntutan: 12 - 15 November)",
      tnc2: "Keperluan Pengeluaran RM33 Angpao Dijamin:",
      tnc2_1: "- Deposit jumlah keseluruhan RM1,111 dan dapatkan Angpow RM33 yang dijamin",
      tnc2_2: "- Winover x5",
      tnc2_3: "- Boleh dimainkan di SEMUA permainan slot",
      tnc2_4: "- Pengeluaran maksimum x10 (RM330)",
      tnc3: "Keperluan Pengeluaran Cabutan Bertuah RM1,111:",
      tnc3_1: "- Deposit RM1,111, seramai 11 pemain akan dipilih untuk memenangi RM1,111 melalui cabutan bertuah",
      tnc3_2: "- Winover x10",
      tnc3_3: "- Hanya boleh main permainan EpicWin & MegaH5",
      tnc3_4: "- Pengeluaran maksimum RM1,111",
      tnc4: "Keperluan Pengeluaran Bonus RM1888: Turnover X7, Jumlah Maksimum Pengeluaran Bonus RM1888, hanya boleh bermain Permainan EpicWin & MegaH5.",
      tnc5: "Bonus ini tidak boleh digabungkan dengan bonus lain",
      tnc6: "Min Winover x3",
      tnc7: "Hanya boleh main permainan SLOT sahaja",
      tnc8: "Untuk menuntut bonus anda sebelum memulakan permainan, sila hubungi LiveChat"
    },
    promo15:{
      title: "RM50 Comeback Bonus",
      tnc1: "Depo sebanyak MYR 500 & dapatkan MYR 20 (segera) + RM30 (bulan depan)",
      tnc2: "Min Winover x4",
      tnc3: "Maksimum dihadkan pada MYR 500",
      tnc4: "Hanya boleh main permainan EpicWin sahaja",
      tnc5: "Untuk menuntut MYR 20 (bonus segera) sila hubungi LiveChat kami",
      tnc6: "Untuk menuntut MYR 30 (bonus bulan depan) , sila hubungi LiveChat kami  pada 1hb setiap bulan ",
    },
    promo16:{
      title: "RM500 Angpao Olimpik EpicWin",
      tnc1: "Pemenang akan dipilih berdasarkan Papan Pendahulu untuk Bilangan Deposit Tertinggi dan Transaksi Pengeluaran Tertinggi.",
      tnc2: "Tempoh Acara: 22 Jul, 24 Jul, 26 Jul, 29 Jul, 31 Jul, 2 Ogos, 5 Ogos, 7 Ogos dan 9 Ogos.",
      tnc3: "22 Jul, 24 Jul, 7 Ogos dan 9 Ogos berdasarkan Papan Pendahulu Bilangan Deposit Tertinggi ",
      tnc4: "26 Jul, 29 Jul, 31 Jul, 2 Ogos dan 5 Ogos berdasarkan Papan Pendahulu Transaksi Pengeluaran Tertinggi",
      tnc5: "3 Pemenang Teratas di Papan Pendahulu boleh memenangi Angpao Olimpik EpicWin:",
      tnc6: "Emas: MYR 500",
      tnc7: "Perak: MYR 200",
      tnc8: "Gangsa: MYR 100",
      tnc9: "Pemenang akan diumumkan pada pukul 6 petang setiap tarikh acara.",
      tnc10: "Minimum Kemenangan adalah x10 (Jumlah bonus pengeluaran maksimum).",
      tnc11: "Sah untuk permainan slot EpicWin dan MegaH5.",
      tnc12: "Tuntutan melalui Sembang Langsung."
    },
    promo17:{
      title: "RM33 Angpao",
      tnc1: "Depo sebanyak MYR 660 & dapatkan MYR 33 Angpao terjamin semasa tempoh promosi Sukan Olimpik ke-33.",
      tnc2: "10 pemain bertuah akan mendapat MYR 660. Pengumuman pemenang pada 8 Ogos 2024 dalam kumpulan Telegram EpicWin. (Tarikh Tuntutan: 8 - 12 Ogos 2024)",
      tnc3: "Keperluan pengeluaran bonus MYR 33: Menang X4, Jumlah Maksimum pengeluaran bonus X10 (MYR 330).",
      tnc4: "Hanya boleh bermain permainan EpicWin & MegaH5 sahaja."
    },
    cny:{
      title: "CNY Deposit RM 2,888 & Menangi RM 2,888 Angpau",
      tnc1: "Tempoh CNY (10 Feb - 24 Feb 2024), deposit RM 2,888, berpeluang untuk menangi sehingga RM 2,888 Angpau.",
      tnc2: "Pemain yang layak akan menerima RM 88 Angpau CNY.",
      tnc3: "8 pemain berpeluang untuk menangi RM 2,888 Angpau dari 25 hingga 28 Feb 2024.",
      tnc4: "Sila hubungi Livechat untuk claim Angpau anda.",
      tnc5: "Turnover: x3",
      tnc6: "Had pengeluaran maksimum: x10, had pada RM 2,888.",
      tnc7: "Hanya untuk permainan EpicWin dan MegaH5."
    },
    tnc: "TERMA & SYARAT",
  },
  payment_option: "Kaedah Pembayaran",
  payment_list: "Pembayaran yang Diterima",
  poker:"Poker",

  ref_num_enter: "Sila masukkan Nombor Rujukan",
  register: "Mendaftar",
  register_now: "Daftar Sekarang",
  responsible_gambling: "Kewajipan dalam Pertaruhan",
  responsible_gaming: "Kewajipan dalam Permainan",
  rebate: "Rebet",
  rejected: "Telah Ditolak",
  result: "KEPUTUSAN",
  reward: "Pemberian",
  rewards: "Pemberian-pemberian",
  referral: "Pengajakan",
  referral_desc: {
    one : "Ajak & Tebus rebat tunai sebanyak ",
    two: "RM20 ",
    three: "bagi setiap ahli baru yang dirujuk tanpa menyertai promosi deposit"
  },
  referral_prefix: "Peroleh RM20 Pulangan Tunai setiap kali ahli yang disyorkan membuat deposit biasa pertama! Link: ",
  referral_code: "Kod Pengajakan",
  resend: "Hantar Semula",
  request_again: "Meminta TAC",
  reference_number: "Nombor Rujukan",
  reference_number_tooltips: "Sila masukkan Nombor Rujukan",
  remarks: "Catatan",
  real_time: "Waktu Nyata",
  recipient_id: "ID Penerima",
  review: "Ulasan | ulasan",
  review_title: "Bagaimana dengan pengalaman pertaruhan anda?",
  registered_player: "Jumlah PEMAIN TERDAFTAR",
  royalty_level:{
    1: 'Gangsa',
    2: 'Perak',
    3: 'Emas',
    4: 'Platinum',
    5: 'Diamond'
  },
  register_title: "Daftar Sekarang",
  reloadpincode: "Reload Pin",
  referral_rebate: "Rabat Rujukan",
  register_date: "Tarikh Pendaftaran",
  reset_password: "Tetapkan Semula Kata Laluan",
  remember_me: "Ingat saya?",
  responsible: "Bermain secara Bertanggungjawab",

  save: "Simpan",
  send: "Hantar",
  social_responsibility: "Tanggungjawab Sosial",
  status: "Status",
  slots:"Slots",
  slotgames: "Slots",
  slot_play: "Play",
  slot_games: "Permainan Slot",
  slot_games_mobile: "Permainan Slots Mudah Alih",
  signup: "Daftar",
  signupform: {
    first_line: "Saya telah berumur 18 tahun ke atas dan  bersetuju untuk mematuhi segalanya",
    account_exist: "Telah mencipta akaun?",
    verification_number: "Nombor Pengesahan",
    problem_assist: "Jika anda menghadapi masalah dalam menerima kod, sila hubungi kami melalui Live Chat.",
    subscription_confirm: "Saya berminat mengetahui lebih lanjut tentang tawaran & promosi via e-mel, teks or postings.",
    account_success_first: "Akaun anda telahpun",
    account_success_second: "berjaya dicipta",
    deposit_now: "Deposit Sekarang Juga"
  },
  submit: "Menyerah",
  select_bonus: "Pilih Bonus",
  spin_again: "PUTAR LAGI",
  success: "Berjaya",
  share_invite_code: "Kongsi Kod Pengajakan anda",
  share_facebook:"Kongsi ke Facebook",
  share_to_friend: "Kongsi bersama dengan Rakanmu",
  share_referral_reward: "Terima RM 10.00 untuk rakan dan anda berdua",
  select_deposit: "Sila pilihkan kaedah deposit",
  survey: {
    1: "Pengalaman Bermain",
    2: "Masa Pengeluaran",
    3: "Khidmat Pelanggan",
    4: "Reka Bentuk Game",
    5: "Ajak Rakan"
  },
  single_highest: "Nisbah Bayar Keluar Tertinggi",
  share_title: "Kongsi Pautan Rujukan:",
  settings: "Settings",
  subject: "Subjek",
  search:"Cari",

  tac_tips: "Tak dapat kod TAC anda? Sila hubungi <u>Live Chat</u> untuk ganjaran yang tersedia!",
  tac_tips2: "Tak dapat kod TAC?",
  time: "Waktu",
  tutorials: "Tutoran",
  type: "Jenis",
  transfer: "Pindahan",
  transfer_amount: "Jumlah Pindahan",
  transaction_history: "Sejarah Transaksi",
  transfer_history: "Sejarah Pindahan",
  tnc: "T&S",
  tnc_full: "Terma dan Syarat",
  tnc_accept_reminder: "Sila merait dalam kotak pilihan untuk bersetuju dengan Terma dan Syarat kami",
  ticket_status: {
    "0": "Telah ditolak",
    "1": "Telah dilulus"
  },
  tac_code : "Kod TAC",
  tac_code_new: "Kod TAC baru telah dihantar ke nombor telefon anda",
  topten_WITHDRAWAL: "telah mengeluarkan",
  topten_DEPOSIT:"telah mendeposit",
  transaction: "Transaksi",
  tutorial_deposit: "Bagaimana Mendeposit Melalui Aplikasi Mudah Alih",
  tutorial_withdrawal: "Bagaimana Membuat Pengeluaran Melalui Aplikasi Mudah Alih",
  tutorial_transfer: "Bagaimana Membuat Pindahan Melalui Aplikasi Mudah Alih",
  tutorial_android: "Bagaimana Muat Turun Aplikasi Mudah Alih - Versi Android",
  tutorial_ios: "Bagaimana Muat Turun Aplikasi Mudah Alih - Versi IOS",
  transfer_fee: "Yuran Pindahan",
  transfer_fee_message: "RM0.20 per transaksi",
  thankyou:{
    header: "Kami mengalu-alukan kunjungan anda ke Keluarga EPIC.",
    description: "Setiap ahli baru akan diberikan ganjaran sebagai tanda penghargaan atas penyertaan anda."
  },
  total_withdrawal: "JUMLAH PENGELUARAN BULANAN",
  total_review: "JUMLAH ULASAN BULANAN",
  top_games: "10 GAMES PALING POPULAR",
  topgames_period: "30 HARI TERKINI",
  tips: "Tips",
  top30: "30 Pemain dengan Deposit Tertinggi",

  username: "Nama Pengguna",
  uh_oh: "Uh-oh!",
  statement: "Penyata",
  upload_file: "Muat Naik Fail",
  upload_file_tooltips: "Saiz file tidak boleh melebihi daripada 200kb dan mestilah dalam format png, jpg atau jpeg",
  update: "Kemas kini",
  update_email: "Kemas kini Alamat Emel",
  update_email_success : "E-mel berjaya dikemas kini",
  unknown: "Tidak diketahui",

  verification_number: "SMS KOD TAC",
  view_transaction_history: "semak sejarah transaksi",
  view_transaction: "Anda boleh menyemak sejerah transaksi hingga 90 hari yang lalu.",
  verification_no_required: "KOD TAC diperlukan",
  phone_no_reminder: "Sila masukkan 4 angka terakhir bagi nombor telefon anda",
  videos: "Video",
  video_link: "URL Video",

  welcome_to: "Selamat Mengunjungi ke",
  welcome_1: "Jenama #1 Dipersembahkan oleh Pencipta Slot.",
  welcome_2: "Dengan Bayaran Terjamin",
  welcome_3: "Kami bukan sekadar sebuah jenama, kami juga adalah Pencipta Slot",
  withdrawal: "Pengeluaran",
  withdraw_required: "Jumlah pengeluaran diperlukan.",
  withdraw_greater_50: "Jumlah pengeluaran mestilah lebih daripada atau seniai dengan 50.",
  worth: "Berjumlah",
  withdrawal_details: "Butiran Pengeluaran",
  withdrawal_details1: "Bilangan Pengeluaran: 5 kali sehari",
  withdrawal_details2: "Jangka Waktu: 1 min: RM 10, 000",
  withdrawal_details3: "Jangka Waktu: 3 min: RM 100, 000 &amp; ke atasnya",
  withdrawal_speed: "Kecepatan Pengeluaran",
  withdrawal_epic: "PENGELUARAN EPIC",
  withdrawal_topten: "10 TRANSAKSI PENGELUARAN TERTINGGI",
  winner_topten: "10 ORG PEMENANG EPIC TERHEBAT",
  withdrawal_reminder: "Peringatan: Untuk mengelakkan kehilangan baki anda, sila keluarkan jumlah penuh jika anda mengambil sebarang promosi.",

  you_won: "Anda telah memenangi",
  you_have: "Anda sudah",
  withdraw_target_tips: "Anda kena mencapai sasaran yang ditetapkan sebelum permohonan pengeluaran diluluskan",

  promo_display:{
    OTB: "Bonus Sambutan",
    UB: "Bonus Deposit Harian",
    VIPB: "Bonus VIP",
    DB: "Bonus Deposit Harian"
  },

  //promotion dropdown
  OTB90: {
    title: "Bonus Sambutan",
    coinvalue: "19000",
    cashvalue: "190",
    percentage: "90"
  },
  OTB100:{
    title: "Bonus Sambutan",
    coinvalue: "60000",
    cashvalue: "600",
    percentage: "100"
  },
  OTB80:{
    title: "Bonus Sambutan",
    coinvalue: "9000",
    cashvalue: "90",
    percentage: "80"
  },
  OTB100D18:{
    title: "Bonus Sambutan",
    coinvalue: "9000",
    cashvalue: "90",
    percentage: "80"
  },
  OTB100D18:{
    title: "Bonus Deposit Harian",
    coinvalue: "11000",
    cashvalue: "110",
    percentage: "10"
  },
  UB10D200:{
    title: "Bonus Deposit Harian",
    coinvalue: "22000",
    cashvalue: "220",
    percentage: "10",
  },
  UB10D30:{
    title: "Bonus Deposit Harian",
    coinvalue: "3300",
    cashvalue: "33",
    percentage: "10",
  },
  UB10D300:{
    title: "Bonus Deposit Harian",
    coinvalue: "33000",
    cashvalue: "330",
    percentage: "10",
  },
  UB10D50:{
    title: "Bonus Deposit Harian",
    coinvalue: "5500",
    cashvalue: "55",
    percentage: "10",
  },
  UB20D10:{
    title: "Bonus Deposit Harian",
    coinvalue: "1200",
    cashvalue: "12",
    percentage: "20",
  },
  UB20D30:{
    title: "Bonus Deposit Harian",
    coinvalue: "3600",
    cashvalue: "36",
    percentage: "20",
  },
  UB20D50:{
    title: "Bonus Deposit Harian",
    coinvalue: "6000",
    cashvalue: "60",
    percentage: "20",
  },
  UB25D100:{
    title: "Bonus Deposit Harian",
    coinvalue: "12500",
    cashvalue: "125",
    percentage: "25"
  },
  UB25D200: {
    title: "Bonus Deposit Harian",
    coinvalue: "25000",
    cashvalue: "250",
    percentage: "25"
  },
  UB25D300:{
    title: "Bonus Deposit Harian",
    coinvalue: "37500",
    cashvalue: "375",
    percentage: "25"
  },
  VIPB110D1000:{
    title: "Bonus VIP",
    coinvalue: "210000",
    cashvalue: "2100",
    percentage: "110"
  },
  VIPB110D3000:{
    title: "Bonus VIP",
    coinvalue: "630000",
    cashvalue: "6300",
    percentage: "110"
  },
  VIPB110D5000:{
    title: "Bonus VIP",
    coinvalue: "1050000",
    cashvalue: "10500",
    percentage: "110"
  },
  VIPB110D10000:{
    title: "Bonus VIP",
    coinvalue: "2100000",
    cashvalue: "21000",
    percentage: "110"
  },
  VIPB200D300:{
    title: "Bonus VIP",
    coinvalue: "50000",
    cashvalue: "500",
    percentage: "MYR 200"
  },
  DB20D10:{
    title: "Bonus Deposit Harian",
    coinvalue: "1200",
    cashvalue: "12",
    percentage: "20"
  },

  turnover_downline: "Jumlah Pertaruhan Ahli Bawahan",
  daily_rebate: "Rebat Permainan Harian",
  redeem_ticket: "Tuntut tiket",
  redeem: "Tuntut",
  turnover_amount: "Jumlah Pertaruhan",
  no_record: "Tiada rekod",
  share: "Kongsi",
  total_downline: "Jumlah Ahli Bawahan",
  rebate_toclaim: "Rebat yang boleh dituntut",
  rebate_total: "Jumlah Rebat",
  provider: "Pengendali",
  turnover: "Jumlah Pertaruhan",
  inbox: "Peti masuk",
  item: "Item",
  sb_custom: "Sportsbook",
  platform: "Platform",
  adjustment: "Pelarasan",
  referee: "Referi",
  game_name: "Nama Game",
  referral_link: "Pautan Rujukan : ",
  trans_time: "Waktu Transaksi",
}
